export default "__VITE_ASSET__hyg4odWn__"